import { useEffect, useId, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { admin_logout } from "../api";
import storageUtils from "../utils/storageUtils";

export default function AccountMenu({ admin, isOwner }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const container = useRef(null);
  const trigger = useRef(null);
  const logoutButton = useRef(null);
  const menuId = useId();
  useEffect(() => {
    if (!open) return;
    logoutButton.current?.focus();
    const outside = (event) => { if (!container.current?.contains(event.target) && !busy) setOpen(false); };
    document.addEventListener("pointerdown", outside);
    return () => document.removeEventListener("pointerdown", outside);
  }, [open, busy]);
  const finish = () => {
    storageUtils.remove("NASadminToken");
    navigate("/login", { replace: true });
  };
  const logout = async () => {
    if (busy) return;
    setBusy(true); setError("");
    try {
      const response = await admin_logout({});
      if (response.status === 200 || response.status === 401) finish();
      else setError(response.msg || "Unable to log out. Please retry.");
    } catch (requestError) {
      if (requestError?.response?.status === 401) finish();
      else setError("Unable to log out. Check your connection and retry.");
    } finally { setBusy(false); }
  };
  const name = admin?.username || "Administrator";
  return <div className="sa-account-menu" ref={container} onKeyDown={(event) => {
    if (event.key === "Escape" && !busy) { setOpen(false); trigger.current?.focus(); }
    if (event.key === "ArrowDown" || event.key === "ArrowUp") { event.preventDefault(); setOpen(true); logoutButton.current?.focus(); }
  }} onBlur={(event) => { if (event.relatedTarget && !event.currentTarget.contains(event.relatedTarget) && !busy) setOpen(false); }}>
    <button ref={trigger} type="button" className="sa-profile sa-profile-button" aria-label="Account menu" aria-haspopup="menu" aria-controls={open ? menuId : undefined} aria-expanded={open} onClick={() => !busy && setOpen(!open)}>
      <span className="sa-user-avatar" aria-hidden="true">{name.split(/\s+/).map((part) => part[0]).join("").slice(0, 2).toUpperCase()}</span>
      <span className="sa-profile-name"><strong>{name}</strong><small>{isOwner ? "System owner" : "Administrator"}</small></span>
      <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="m3 4.5 3 3 3-3" fill="none" stroke="currentColor" strokeWidth="1.5" /></svg>
    </button>
    {open && <div className="sa-account-popover">
      <div role="menu" id={menuId} aria-label="Account actions">
        <button ref={logoutButton} type="button" role="menuitem" onClick={logout} disabled={busy}>{busy ? "Logging out..." : "Log out"}</button>
      </div>
      {error && <p className="sa-logout-error" role="alert">{error}</p>}
    </div>}
  </div>;
}
